export default __webpack_public_path__ + "static/python-logo-52d7bb207f9868b90e392324f48d9db7.png";